import { render, staticRenderFns } from "./TemplateVariables.vue?vue&type=template&id=56691487&"
import script from "./TemplateVariables.vue?vue&type=script&lang=js&"
export * from "./TemplateVariables.vue?vue&type=script&lang=js&"
import style0 from "./TemplateVariables.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports